import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Music } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const InstagramIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
  </svg>
);

const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
  </svg>
);

const YouTubeIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);

const SpotifyIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
  </svg>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();
  const [socials, setSocials] = useState({
    instagram_url: 'https://instagram.com/OGMUSICGROUP_',
    instagram_handle: '@OGMUSICGROUP_',
    tiktok_url: 'https://tiktok.com/@OG.MUSIC.GROUP',
    tiktok_handle: 'OG.MUSIC.GROUP',
    youtube_url: 'https://youtube.com/@OGMUSICGROUP',
    youtube_handle: '@OGMUSICGROUP',
    spotify_url: '',
    spotify_handle: '',
  });

  useEffect(() => {
    axios.get(`${API_URL}/api/content/socials`).then(res => {
      if (res.data?.content && Object.keys(res.data.content).length > 0) {
        setSocials(prev => ({ ...prev, ...res.data.content }));
      }
    }).catch(() => {});
  }, []);

  const footerLinks = {
    [t('footer.music')]: [
      { name: t('nav.catalog'), href: '/catalog' },
      { name: t('nav.packs'), href: '/packs' },
      { name: t('nav.licenses'), href: '/#licenses' },
      { name: t('nav.membership'), href: '/membership' },
    ],
    [t('footer.company')]: [
      { name: t('nav.about'), href: '/about' },
      { name: t('nav.artists'), href: '/artists' },
      { name: t('nav.services'), href: '/#services' },
      { name: t('footer.contact'), href: '/#contact' },
    ],
    [t('footer.support')]: [
      { name: t('footer.faq'), href: '/faq' },
      { name: t('footer.terms'), href: '/terms' },
      { name: t('footer.privacy'), href: '/privacy' },
      { name: t('footer.refund'), href: '/refund' },
    ],
  };

  const socialPlatforms = [
    { icon: InstagramIcon, url: socials.instagram_url, handle: socials.instagram_handle, label: 'Instagram', color: '#E4405F', bg: '#E4405F' },
    { icon: TikTokIcon, url: socials.tiktok_url, handle: socials.tiktok_handle, label: 'TikTok', color: '#ffffff', bg: '#ffffff' },
    { icon: YouTubeIcon, url: socials.youtube_url, handle: socials.youtube_handle, label: 'YouTube', color: '#FF0000', bg: '#FF0000' },
  ].filter(s => s.url);

  const socialIcons = [
    { icon: InstagramIcon, url: socials.instagram_url, label: 'Instagram' },
    { icon: TikTokIcon, url: socials.tiktok_url, label: 'TikTok' },
    { icon: YouTubeIcon, url: socials.youtube_url, label: 'YouTube' },
    { icon: SpotifyIcon, url: socials.spotify_url, label: 'Spotify' },
  ].filter(s => s.url);

  return (
    <footer className="bg-[#030305] border-t border-white/5">
      {/* Social Media Section */}
      {socialPlatforms.length > 0 && (
        <div className="border-b border-white/5" data-testid="social-media-section">
          <div className="container-custom py-12 md:py-16">
            <div className="text-center mb-10">
              <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#E8720C] mb-3">{t('social.followUs')}</p>
              <h3 className="text-2xl md:text-3xl font-bold tracking-tight">
                OG MUSIC <span className="gold-text">{t('social.everywhere')}</span>
              </h3>
            </div>
            <div className="flex flex-wrap justify-center gap-4 md:gap-6">
              {socialPlatforms.map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="glass-card px-6 py-4 flex items-center gap-4 hover:-translate-y-1 transition-all duration-300 group min-w-[200px]"
                  data-testid={`social-link-${social.label.toLowerCase()}`}
                >
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0" style={{ backgroundColor: `${social.bg}15` }}>
                    <social.icon className="w-5 h-5" style={{ color: social.color }} />
                  </div>
                  <div>
                    <p className="text-xs text-white/40">{social.label}</p>
                    <p className="text-sm font-semibold group-hover:text-[#E8720C] transition-colors">{social.handle}</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Main Footer Content */}
      <div className="container-custom py-16 md:py-24">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-16">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-bold tracking-tight">
                <span className="text-white">OG</span>
                <span className="gold-text ml-1">MUSIC</span>
              </span>
            </Link>
            <p className="text-white/50 text-sm leading-relaxed mb-6">
              {t('footer.tagline')}
            </p>
            <div className="flex gap-3">
              {socialIcons.map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#E8720C]/20 flex items-center justify-center transition-colors"
                  data-testid={`social-icon-${social.label.toLowerCase()}`}
                >
                  <social.icon className="w-4 h-4 text-white/60" />
                </a>
              ))}
            </div>
          </div>

          {/* Link Columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white/50 mb-4">{title}</h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link to={link.href} className="text-sm text-white/60 hover:text-white transition-colors">{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Large Brand Text */}
        <div className="border-t border-white/5 pt-12">
          <h2 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tighter text-white/5 text-center select-none">
            OG MUSIC GROUP
          </h2>
        </div>

        {/* Copyright */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 mt-8 pt-8 border-t border-white/5">
          <p className="text-xs text-white/40">
            &copy; {currentYear} OG Music Group. {t('footer.copyright')}
          </p>
          <p className="text-xs text-white/40">
            {t('footer.madeWith')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
